module.exports = __webpack_public_path__ + "img/icon_4_1.91526168.png";